var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "page" }, [
    _c(
      "div",
      { staticClass: "page-content" },
      [
        _c("f7-searchbar", {
          staticClass: "search",
          attrs: { "cancel-link": "Cancel", "search-list": "#search-list" },
          on: {
            "searchbar:search": _vm.onSearch,
            "searchbar:enable": _vm.onEnable,
            "searchbar:disable": _vm.onDisable,
            "searchbar:clear": _vm.onClear,
          },
        }),
        _vm._v(" "),
        _c("div", { staticClass: "layoutSubtitle" }),
        _vm._v(" "),
        _c(
          "f7-list",
          { staticClass: "searchbar-not-found" },
          [_c("f7-list-item", { attrs: { title: "Nothing found" } })],
          1
        ),
        _vm._v(" "),
        _c(
          "f7-list",
          {
            staticClass: "searchbar-found",
            attrs: { id: "search-list", sortable: "" },
          },
          [
            _c("cm-accounts-list", {
              attrs: { accounts: _vm.accountsItems, filterBy: _vm.filterBy },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "toolbarPageBottomBlank" }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }